import React, { useEffect, useState, useRef } from "react";

import PageContentLayoutTemplate from "../LayoutModule/PageContentLayoutTemplate";
import AutohideSnackbar from "../LayoutModule/autohideSnackbar";
import CaseHistoryForm from "./CaseHistoryForm";
import useCaseAPIDetails from "../../api/caseAPIDetails"; //
import useCaseHistoryAPIDetails from "../../api/caseHistoryAPIDetails"; //
import AppGlobalStaticData from "../../appdata/appStaticData";
import { useParams } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Box,
  IconButton,
  Tooltip,
  Button,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";
import {
  Edit,
  Add,
  History,
  AccountCircle,
  CalendarToday,
  Gavel,
  Delete,
} from "@mui/icons-material";

const CaseDetailsPage = ({ caseDetails, courtList, onEditCase }) => {
  const [open, setOpen] = useState(false);
  //const [openCaseEdit, setOpenCaseEdit] = useState(false);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [selectedHistoryId, setSelectedHistoryId] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [snackbarProperties, setSnackbarProperties] = useState({
    duration: 0,
    message: "",
    serverity: "",
  });
  const { deleteData } = useCaseAPIDetails();
  const { deleteCaseHistoryData, getCaseHistoryList } =
    useCaseHistoryAPIDetails();
  const [caseHistorydeleteOpen, setCaseHistoryDeleteOpen] = useState(false);
  const [caseHistoryDeleteId, setCaseHistoryDeleteID] = useState(0);

  const [caseDeleteOpen, setCaseDeleteOpen] = useState(false);
  const [caseDeleteId, setCaseDeleteID] = useState(0);
  const globalData = new AppGlobalStaticData();
  const handleOpen = (id) => {
    setSelectedHistoryId(null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedHistoryId(null);
  };

  const onEditHistory = (id) => {
    setSelectedHistoryId(id);
    setOpen(true);
  };

  const getCaseHistory = (id) => {
    getCaseHistoryList(id)
      .then((caseHistoryData) => {
        if (!caseHistoryData) {
          setSnackbarProperties({
            duration: globalData.Duration,
            message: globalData.FetchCaseFailed,
            severity: globalData.SeverityError,
          });
          console.error("Failed to fetch case details");
        } else {
          setHistoryData(caseHistoryData);
        }
      })
      .catch((error) => {
        console.error("Error fetching case details:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCaseHistory(id);
  }, [id, caseDetails]);

  const handleDelete = async (id) => {
    setLoading(true);
    const success = await deleteData(id);
    if (success) {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: success
          ? globalData.DeleteCaseSuccess
          : globalData.DeleteCaseFailed,
        serverity: success
          ? globalData.SeveritySuccess
          : globalData.SeverityError,
      });
      //
    } else {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.DeleteCaseFailed,
        serverity: globalData.SeverityError,
      });
    }
    setLoading(false);
  };

  // case delete
  const handleDeletePopup = async () => {
    await handleDelete(caseDeleteId);
    setCaseDeleteOpen(false);
  };

  const handleDeletePopupOpen = async (id) => {
    //await handleDelete(id);
    setCaseDeleteOpen(true);
    setCaseDeleteID(id);
  };

  const handleCaseHistoryDeletePopupOpen = async (id) => {
    //await handleDelete(id);
    setCaseHistoryDeleteOpen(true);
    setCaseHistoryDeleteID(id);
  };

  const handleCaseHistoryDelete = async () => {
    setLoading(true);
    setCaseHistoryDeleteOpen(false);
    const success = await deleteCaseHistoryData(caseHistoryDeleteId);
    if (success) {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: success
          ? globalData.DeleteCaseSuccess
          : globalData.DeleteCaseFailed,
        serverity: success
          ? globalData.SeveritySuccess
          : globalData.SeverityError,
      });
      //
    } else {
      setSnackbarProperties({
        duration: globalData.Duration,
        message: globalData.DeleteCaseFailed,
        serverity: globalData.SeverityError,
      });
    }
    getCaseHistory(id);
    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #f4f4f4, #e0e0e0)",
        padding: 3,
      }}
    >
      {/* Case Details Section */}
      <Card sx={{ mb: 3, p: 2, borderRadius: 2 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Case Details</Typography>
            <Tooltip title="Edit Case">
              <Button
                variant="contained"
                startIcon={<Edit />}
                onClick={onEditCase}
              >
                Edit Case
              </Button>
            </Tooltip>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Grid container spacing={2}>
            {Object.entries(caseDetails)
              .filter(
                ([key]) =>
                  key !== "created_at" &&
                  key !== "updated_at" &&
                  key !== "caseStatus" &&
                  key !== "isactive"
              ) // Exclude specific keys
              .map(([key, value]) => {
                if (key === "courtID") {
                  const court = courtList.filter((x) => x.id == value)[0];
                  if (court) {
                    value = court.Place + " - " + court.CourtName;
                    key = "courtName"; // Update the displayed key
                  }
                }

                return (
                  <Grid item xs={12} sm={6} key={key}>
                    <Typography variant="body1">
                      <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>{" "}
                      {value}
                    </Typography>
                  </Grid>
                );
              })}
          </Grid>
        </CardContent>
      </Card>
      <Divider />
      <PageContentLayoutTemplate pageName={"Case History"} tooltip={""}>
        <Timeline>
          {historyData.map((item, index) => (
            <TimelineItem key={index}>
              <TimelineSeparator>
                <TimelineDot color="primary">
                  <History />
                </TimelineDot>
                {index !== historyData.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent>
                <Box sx={{ p: 2, borderRadius: 2, bgcolor: "grey.100", mb: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {item.hearing_message}
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() => onEditHistory(item.id)}
                        sx={{ ml: 1 }}
                      >
                        <Edit fontSize="small" color="primary" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() =>
                          handleCaseHistoryDeletePopupOpen(item.id)
                        }
                        sx={{ ml: 1 }}
                      >
                        <Delete fontSize="small" color="secondary" />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                  {/* <Typography variant="body2" color="textSecondary">
                    <AccountCircle
                      fontSize="small"
                      sx={{ verticalAlign: "middle", mr: 1 }}
                    />
                    {item.updatedBy}
                  </Typography> */}
                  <Typography variant="caption" color="textSecondary">
                    <CalendarToday
                      fontSize="small"
                      sx={{ verticalAlign: "middle", mr: 1 }}
                    />
                    {item.hearing_date}
                  </Typography>
                </Box>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </PageContentLayoutTemplate>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          {selectedHistoryId ? "Edit Case History" : "Create Case History"}
        </DialogTitle>
        <DialogContent>
          <CaseHistoryForm
            id={selectedHistoryId}
            caseid={caseDetails.id}
            onClose={handleClose}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={caseHistorydeleteOpen}
        onClose={() => setCaseHistoryDeleteOpen(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to delete this case history record? This
            action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCaseHistoryDeleteOpen(false)}
            color="primary"
          >
            Cancel
          </Button>
          <Button onClick={() => handleCaseHistoryDelete()} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CaseDetailsPage;
